<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import { Datetime } from 'vue-datetime';
import { get } from 'lodash';

import { IRI } from '@/api';

export default {
  name: 'ModuleInvitationsBulk',
  components: {
    Datetime,
  },
  computed: {
    ...mapState('course/collection', {
      courses: 'items',
    }),
    ...mapState('invitation/bulk', [
      'item',
    ]),
    invitationCourses: {
      get() {
        const courses = get(this, 'item.courses', []);
        return courses.map(course => course.course.replace(IRI.course, ''));
      },
      set(values) {
        const { item } = this;
        item.courses = values.map(value => ({
          course: `${IRI.course}${value}`,
          expiresAt: item.expiresAt,
        }));
        this.setItem(item);
      },
    },
    codes: {
      get() {
        return this.item.codes.join('\n');
      },
      set(value) {
        const { item } = this;
        item.codes = value.split('\n');
        this.setItem(item);
      },
    },
    expiresAt: {
      get() {
        return this.item.expiresAt;
      },
      set(value) {
        const { item } = this;
        item.courses = item.courses.map(course => {
          course.expiresAt = value;
          return course;
        });
        item.expiresAt = value;
        this.setItem(item);
      },
    },
  },
  methods: {
    ...mapActions('course/collection', {
      fetchCourses: 'fetch',
    }),
    ...mapActions('invitation/bulk', [
      'create',
    ]),
    ...mapMutations('invitation/bulk', [
      'setItem',
      'reset',
    ]),
    localCreate () {
      this.create()
        .then(() => {
          this.$router.push({ name: 'invitations-listing' });
        })
      ;
    },
  },
  created() {
    this.fetchCourses(false);
  },
};
</script>
<template>
  <div class="box">
    <h2>General</h2>
    <div class="form-group mt-3">
      <label for="course" class="d-block">Course</label>
      <select id="course" multiple class="form-control rounded-0" v-model="invitationCourses">
        <option value="" disabled>Select Course(s)</option>
        <option v-for="course in courses" :key="course.id" :value="course.id">{{ course.title }}</option>
      </select>
    </div>
    <div class="form-group mt-3">
      <label for="expiresAt" class="d-block">Expiration Date</label>
      <Datetime input-id="expiresAt" input-class="form-control rounded-0" v-model="expiresAt" />
    </div>
    <div class="form-group mt-3">
      <label for="codes" class="d-block">Codes</label>
      <small class="d-block">One code per line</small>
      <textarea id="codes" class="form-control rounded-0" v-model="codes"></textarea>
    </div>
    <div class="form-group mt-3 text-right">
      <button class="btn btn-primary" @click="localCreate">Generate</button>
    </div>
  </div>
</template>
